import i18n from '@/utils/i18n';
import { MessageBox } from 'element-ui'
import '@/styles/confirm.scss'

const confirm = function(ctx, title = i18n.t("common.notice"), { conBtn, canBtn, _customClass, ...options  } = { conBtn, canBtn, _customClass,  ...options  }) {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(ctx, title, {
      confirmButtonText: conBtn || i18n.t("common.ok2"),
      cancelButtonText: canBtn || i18n.t("common.cancel"),
      customClass: _customClass || 'v-confirm', // confirm-class
      dangerouslyUseHTMLString: true, // 是否使用HTML片段
      ...options
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
    })
  })
}

export default confirm
